<script setup lang="ts">
const emit = defineEmits<(e: "refetch:tableResults") => void>();
</script>

<template>
  <div class="container">
    <p>
      <lds-icon name="lds-icon-WarningFilled"></lds-icon> Failed to fetch
      results.
    </p>
    <lds-button
      colour="primary"
      variant="text"
      @click="() => emit('refetch:tableResults')"
    >
      Try again
    </lds-button>
  </div>
</template>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $spacing-s;
  margin-top: $spacing-l;
}

p {
  margin: 0;
  display: flex;
  align-items: center;
  color: $color-neutral-800;
}

p lds-icon {
  margin-right: $spacing-xs;
  color: $color-danger-600;
}
</style>
